import React from 'react';

import StatusPanel from '../StatusPanel';

interface IFolderExportProps {
  visible: boolean;
  loading?: boolean;
  onClose?: () => void;
}

const FolderExport: React.FC<IFolderExportProps> = ({ visible, loading, onClose }) => {
  return <StatusPanel.LoadingPanel group="Folder: Export" loading={loading} visible={visible} onClose={onClose} />;
};

export default FolderExport;
